module.exports = __webpack_public_path__ + "img/9.b2e66025.jpg";